import { Route } from "react-router-dom";
import { currentUserSelector } from "../../redux/reducers/userSlice";
import { useAppSelector } from "../../redux/store";
import ErrorBoundaryRoutes from "../../shared/error-boundary-routes";
import PageNotFound from "../../shared/page-not-found";
import AccomodationInspectionDetailPage from "./accomodation-inspection-detail.page";
import AccomodationInspectionListPage from "./accomodation-inspection-list.page";

const AccomodationInspectionRoutes = () => {
  const currentUser = useAppSelector(currentUserSelector);
  const isAdministrator = currentUser?.authorityChecks.isAdministrator;
  const isSportellista = currentUser?.authorityChecks.isSportellista;
  const isOperatore = currentUser?.authorityChecks.isOperatore;

  return (
    <ErrorBoundaryRoutes>
      {currentUser && (isSportellista || isAdministrator || isOperatore) && (
        <>
          <Route path="" element={<AccomodationInspectionListPage />} />
          {!isOperatore && (
            <Route
              path="/create"
              element={<AccomodationInspectionDetailPage edit />}
            />
          )}
          <Route path=":id" element={<AccomodationInspectionDetailPage />} />
          {!isOperatore && (
            <Route
              path=":id/edit"
              element={<AccomodationInspectionDetailPage edit />}
            />
          )}
        </>
      )}
      <Route path="*" element={<PageNotFound />} />
    </ErrorBoundaryRoutes>
  );
};

export default AccomodationInspectionRoutes;
